import React, {useState} from "react";
import { useRouter } from 'next/router';
import { socialLogin } from '../../lib/api/auth';
import { notifyMe } from "../../helper";
import Link from 'next/link';
import { setCookies, getCookies, removeCookies } from 'cookies-next';
import { getprofile } from '../../lib/api/myspace'
import { GoogleLogin } from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';


const SocialLoginButton = ({path, findCart, setUserDataStored}) => {
    const router = useRouter();
    const clientId ='240282502182-kplp2cs6nco5dhor2m5k4qvsm2u5csbv.apps.googleusercontent.com';

    const onSocialLoginGoogleSuccess = (res) => {
        if(res?.profileObj?.googleId !== "")
        {
            const socialdata = { "name": res?.profileObj?.givenName, "surname": res?.profileObj?.familyName, "email": res?.profileObj?.email, "googleId": res?.profileObj?.googleId};
            socialLoginRequest(socialdata);
        }
    }
    const onSocialLoginFacebookSuccess = (response) => {
        const name_separated = response?.name.split(' ');
        const socialdata = { name: name_separated[0], surname: name_separated[1], email: response?.email, facebookId:response?.id};
        socialLoginRequest(socialdata);
    }    
    const onSocialLoginFailure = (res) => {
        notifyMe({ key: 'signIn', method: 'error', message: 'Error al hacer login, inténtalo más tarde.' });
    };
    const socialLoginRequest = async (socialresponse) =>
    {
        const response = await socialLogin(socialresponse);
        if(response.success === true) {

            setCookies('eccauthToken', response.data.authToken,{ maxAge: 60 * 60 * 24 * 30 });
            const resp = await getprofile();
            if(!resp.success) {
                notifyMe({ key: 'signIn', method: 'error', message: 'Fallo en Login', description: 'Usuario desconocido' });
                return;
            }

            setUserDataStored(resp.data);   
            notifyMe({ key: 'signIn', method: 'success', message: 'Login success', description: 'Successfully logged in' });
            await findCart();
            if(path == 'cart') {
                if(!resp.apellidos || resp.apellidos==''){
                    router.push('/checkout/myDataStep');
                }else{
                    router.push('/checkout/step3');
                }
                
            } else {
                router.push('/');
            }
        }else{
            if(response.responseCode === 138)
            {
                notifyMe({ key: 'signIn', method: 'error', message: 'Error', description: 'El usuario no coincide, ponte en contacto con assistente@ecccomics.com' });
            }
            else if(response.responseCode === 139)
            {
                notifyMe({ key: 'signIn', method: 'error', message: 'Error, no puede hacer LogIn', description: 'Usuario sin identificar, no puede hacer LogIn' });
            }
            else if(response.responseCode === 140)
            {
                notifyMe({ key: 'signIn', method: 'error', message: 'Error', description: 'Usuario sin email, no puede hacer LogIn' });
            }
        }
    }

    return (
        <>
        <div className="facebook">
            <FacebookLogin
            appId="237597484881958"
            autoLoad={false}
            fields="name,email"
            callback={onSocialLoginFacebookSuccess}
            render={renderProps => (
                <button className="facebook-login-btn" onClick={renderProps.onClick}><img src="/assets/images/facebook.png" /></button>
                )}/>
        </div>

        <div className="google">
            <GoogleLogin
            clientId={clientId}
            onSuccess={onSocialLoginGoogleSuccess}
            onFailure={onSocialLoginFailure}
            render={renderProps=>(<button className="google-login-btn" onClick={renderProps.onClick} disabled={renderProps.disabled}> <img src="/assets/images/google.png" /></button>)}
            cookiePolicy={'single_host_origin'}
            isSignedIn={false} 

            />
        </div>
        </>
    )
}

export default SocialLoginButton;
